module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-regular-400.eot?2746742c09b070f74bd7d555e6b959fa";